import React, { useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { notifications } from '@mantine/notifications';
import { VisiLoader } from "../../components/GeneralComponent/GeneralComponent";
import TestsApi from "../../api/TestsApi";
import { setVisiUserSession } from '../../GeneralFunction';

// Direct link from a notification button (Build 1 change 36): /open-test?t=<test>&m=<account>[&a=autoconclude |
// &a=setwinner&v=<variation> | &a=keeprunning] (the last two are the runoff choice's buttons, change 31).
// Resolves the link's test, selects its website, and opens it the same way clicking it in Review Tests does.
export function OpenTest() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    TestsApi.opentestlink({ t: params.get('t') || '', m: params.get('m') || '' })
      .then(response => {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
          return null;
        }
        return response.json();
      })
      .then(result => {
        if (!result) return;
        if (result.status === 1 && result.data && Number(result.data.concluded) === 1) {
          navigate('/test-history', { replace: true });
        } else if (result.status === 1 && result.data) {
          setVisiUserSession('website', result.data.system_website_id);
          navigate('/reviewing-test', {
            replace: true,
            state: {
              pageId: result.data.page_id,
              taguchiTestId: result.data.taguchi_test_id,
              funnelId: result.data.funnel_id,
              testsId: result.data.tests_id,
              openAutoConclude: params.get('a') === 'autoconclude',
              openSetWinner: params.get('a') === 'setwinner' ? Number(params.get('v')) || 0 : 0,
              openKeepRunning: params.get('a') === 'keeprunning',
            },
          });
        } else {
          notifications.show({ color: 'orange', title: 'Open test', message: (result && result.message) || 'This test could not be opened.' });
          navigate('/review-tests', { replace: true });
        }
      })
      .catch(() => navigate('/review-tests', { replace: true }));
  }, []);

  return <VisiLoader VisiLoaderVisible={true} />;
}
